import { getCookie } from "../utils/cookieManager";
import { refreshToken } from "./refreshToken";
import { checkRefresh } from "./setTokens";
export { isLoggedIn };
async function isLoggedIn() {
  var id_token = getCookie('id_token');
  if (!id_token) return false;
  var access_token = getCookie('access_token');
  if (access_token) {
    checkRefresh();
    return true;
  }
  var tokens = await refreshToken();
  return !!tokens;
}